import React, { useRef, useState } from "react";
import product_img from "./assets/tool2.png";
import product1 from "./assets/catologue/bmt-tool-holders.jpg";
import pdf1 from "./assets/catologue/bmt-tool-holders.pdf";
import product2 from "./assets/catologue/driven-tool-holder.jpg";
import pdf2 from "./assets/catologue/driven-tool-holder.pdf";
import product3 from "./assets/catologue/reduction-sleeves.jpg";
import pdf3 from "./assets/catologue/reduction-sleeves.pdf";
import product4 from "./assets/catologue/slotted-tool-disc.jpg";
import pdf4 from "./assets/catologue/slotted-tool-disc.pdf";
import product5 from "./assets/catologue/vdi-td-th-13.jpg";
import pdf5 from "./assets/catologue/vdi-td-th-13.pdf";
import product6 from "./assets/catologue/vtp-tool-holder.jpg";
import pdf6 from "./assets/catologue/vtp-tool-holder.pdf";
import Slider from "react-slick";
import { Button, Form, Modal } from "react-bootstrap";
import emailjs from "@emailjs/browser";
import axios from "axios";
import { useEffect } from "react";

export default function Catologue() {
  const CatogueContent = [
    {
      id: 23,
      title: `ANGULAR HEAD BROCHURE AUG 2025`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/catalogues/Angular-Head-Brochure-Aug-2025_KkZ5fc1y4.jpg`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      new: true,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Angular%20Head%20Brochure%20Aug%202025_pXsuAE-UL.pdf",
    },
    {
      id: 22,
      title: `GEAR HOBBING UNIT BROCHURE`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/catalogues/thumnail_Svdbgg05I.jpg`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      new: true,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Gear%20Hobber%20Brochure%20%202025_4FZv4jZDD.pdf",
    },
    {
      id: 21,
      title: `GEAR HOBBING UNIT FLYER`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/catalogues/gear%20hobber%20flyer_Juow5zuQ-M.jpg?updatedAt=1761546965409`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      new: true,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Gear%20Hobber%20Flyer%20%202025_Ah0e9GFQX.pdf?updatedAt=1761378307422",
    },
    {
      id: 20,
      title: `POWER SKIVING UNIT`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/catalogues/power%20skiving%20flyer_aDHLzZf7l.jpg?updatedAt=1761546966007`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      new: true,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Power%20Skiving%20Flyer%20Sep%202025%20(1)_gx2qIQjrw.pdf?updatedAt=1761378305000",
    },
    {
      id: 19,
      title: `THREAD WHIRLING UNIT`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/catalogues/thread%20whirling%20flyer_8DEcB8J4u.jpg?updatedAt=1761546965802`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      new: true,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Thread%20whirling%20Flyer%20(1)_a-6z8OPZR.pdf?updatedAt=1761378304964",
    },
    {
      id: 18,
      title: `EASY MOUNT`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/catalogues/easy%20mount%20flyer_3v4CipAmxB.jpg?updatedAt=1761546965201`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      new: true,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Easy%20Mount%20Flyer%20Sep%202025_YdWyFShds.pdf?updatedAt=1761378304242",
    },
    {
      id: 17,
      title: `SLOTTING HEAD`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/catalogues/slotting%20head_rDr5pGn0c.jpg?updatedAt=1761546965822`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      new: true,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/SLOTTING%20HEAD%20FOR%20CNC%20TURN%20MILL%20CENTER_OaQpGcGow.pdf?updatedAt=1761378302506",
    },
    {
      id: 16,
      title: `SPHOORTI CATALOGUE 2025`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/catalogue_home/Screenshot%202025-05-21%20183037_3kV1-EBn3b.png?updatedAt=1747833123328`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      new: true,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Sphoorti%20New%20Catalogue%202025%20(1)-compressed_compressed%20(1)_11zon_LdhMrlMn9.pdf?updatedAt=1747832055569",
    },
    {
      id: 12,
      title: `VDI PSC(CAPTO-COMPATIBLE) TOOL HOLDERS`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/catalogue_home/vdi-psc-leflet-sphoorti_oMqXxL3u3.jpg?updatedAt=1725628842032`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      new: true,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/VDI%20PSC%20Leaflet%20Sphoorti%20(1)_g2uvQj-QKk.pdf?updatedAt=1725630458383",
    },

    {
      id: 15,
      title: `SPHOORTI TOOL DISCS & TOOL HOLDERS`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/catalogue_home/final-bmt-tool-disc--page-1_KR_PsFmgqk.jpg?updatedAt=1725628841691`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      new: true,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Tool%20Disc%20Leaflet%20English%209825%20vkp_compressed_wLryranobD.pdf",
    },

    {
      id: 9,
      title: `BMT PSC(CAPTO-COMPATIBLE) TOOL HOLDER`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/catalogue_home/bmt-tool-page1%20(1)_jliANgBRQ.jpg?updatedAt=1725628841744`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      new: true,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/BMT%20Tool%20Holders%20Aug%202024%2016%20Pages-1%20(2)_8tk6LphIA.pdf?updatedAt=1725630257804",
    },

    // {
    //   id: 11,
    //   title: `ANGULAR HEAD`,
    //   imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/catalogue_home/angular-head-leaf-page-1__WYvqT2OI.jpg?updatedAt=1725628841478`,
    //   imgName: "product_img.png",
    //   pdf: `${pdf4}`,
    //   new: true,
    //   pdfLink:
    //     "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Angular%20Head%20Leaflet%20Sep%202024%20(2)_yaD2CEf5a.pdf?updatedAt=1725630259594",
    // },

    {
      id: 1,
      title: `SLOTTED TOOL DISCS & TOOL HOLDERS`,
      imageURL: `https://ik.imagekit.io/0rsvz9vomoe/catalog_home/slotted-tool-disc_1gXLabjAN.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1645703468416`,
      imgName: "product_img.png",
      pdf: `${pdf4}`,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Slotted_Tool_Discs_Jan_2023_compressed_HbgzHrB28.pdf?ik-sdk-version=javascript-1.4.3&updatedAt=1673859158271",
    },
    {
      id: 2,
      title: `VDI TOOL DISCS & TOOL HOLDERS`,
      imageURL: `https://ik.imagekit.io/0rsvz9vomoe/catalog_home/vdi-td-th-13_uHphSHcgo.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1645703468579`,
      imgName: "product_img.png",
      pdf: `${pdf5}`,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/VDI_TD___TH_Jan_2023_compressed_unKobpSWG.pdf?ik-sdk-version=javascript-1.4.3&updatedAt=1673859170245",
    },
    {
      id: 5,
      title: `VDI DRIVEN TOOL HOLDERS`,
      imageURL: `https://ik.imagekit.io/0rsvz9vomoe/catalog_home/driven-tool-holder_lCEqKZFvw.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1645703467261`,
      imgName: "product_img.png",
      pdf: `${pdf2}`,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Driven_Tool_Holders_Jan_2023_compressed_CuTC2pqK8.pdf?ik-sdk-version=javascript-1.4.3&updatedAt=1673859034942",
    },
    {
      id: 3,
      title: `BMT TOOL DISCS AND TOOL HOLDERS`,
      imageURL: `https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/catalogues/WhatsApp%20Image%202025-08-28%20at%201.17.59%20PM_lXWhuXj_vR.jpeg?updatedAt=1756368232691`,
      imgName: "product_img.png",
      pdf: `${pdf1}`,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/bmt-tool-disc-tool-holders-april-2025_ARoErMc1Fu.pdf?updatedAt=1756368526198",
    },
    {
      id: 4,
      title: `VTP TOOL HOLDERS`,
      imageURL: `https://ik.imagekit.io/0rsvz9vomoe/catalog_home/vtp-tool-holder_PbmifuPTh.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1645703468828`,
      imgName: "product_img.png",
      pdf: `${pdf6}`,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/VTP_Tool_Holders_Jan_2023_compressed_ok5iAyKOw.pdf?ik-sdk-version=javascript-1.4.3&updatedAt=1673859078144",
    },

    {
      id: 6,
      title: `REDUCTION SLEEVES`,
      imageURL: `https://ik.imagekit.io/0rsvz9vomoe/catalog_home/reduction-sleeves_TW7sEJF44XHW.jpg?ik-sdk-version=javascript-1.4.3&updatedAt=1645703467550`,
      imgName: "product_img.png",
      pdf: `${pdf3}`,
      pdfLink:
        "https://ik.imagekit.io/znuaavymv/Sphoorti_Main_Website/Home/docs/Reduction_Sleeves_Jan_2023_compressed_JFU70f6EA.pdf?ik-sdk-version=javascript-1.4.3&updatedAt=1673859160184",
    },
  ];
  var settings = {
    dots: true,
    // autoplay: true,
    // autoplaySpeed: 2000,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    pauseOnHover: true,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const [show, setShow] = useState({ show: false, pdfId: "1" });
  // const [show, setShow] = useState({ show: false, pdfId: "1" });
  const [EmailValue, setEmailValue] = useState("");
  const [NameValue, setNameValue] = useState("");
  const [CompanyNameValue, setCompanyNameValue] = useState("");
  const [MobileValue, setMobileValue] = useState("");
  const [dataCollected, setDataCollected] = useState(false);

  const handleClose = () => setShow(false);

  useEffect(() => {
    if (localStorage.getItem("dataCollected")) {
      setDataCollected(true);
    }
  }, []);

  const pdfload = (id) => {
    const pdfItem = CatogueContent.filter((item) => item.id === parseInt(id));
    setDataCollected(true);
    localStorage.setItem("dataCollected", true);
    window.open(`${pdfItem[0].pdfLink}`);
  };
  const pdfloadView = (id) => {
    const pdfItem = CatogueContent.filter((item) => item.id === parseInt(id));
    window.open(`${pdfItem[0].pdfLink}`);
  };
  const handleShow = (id) => {
    if (dataCollected) {
      setShow((prevValues) => {
        return {
          // show: true,
          pdfId: id,
        };
      });
      pdfload(id);
    } else {
      setShow((prevValues) => {
        return {
          show: true,
          pdfId: id,
        };
      });
    }
    // pdfId = id;
  };
  const handleSubmit = () => {
    // sessionStorage.setItem("item_key", "item_value");
    // var item_value = sessionStorage.getItem("item_key");
    setShow((prevValues) => {
      return {
        ...prevValues,
        show: false,
      };
    });
    var payload = {
      service_id: "service_6y2mx6c",
      template_id: "template_ym3e0z5",
      user_id: "Za3wa01HeoeXmQqsY",
      template_params: {
        html_message: `
          customer email: ${EmailValue},
          customer name: ${NameValue},
          company name: ${CompanyNameValue},
          mobile number: ${MobileValue}
        `,
        mail_title: `
          Customer info from catalogue
        `,
      },
    };
    axios({
      method: "post",
      url: "https://api.emailjs.com/api/v1.0/email/send",
      data: JSON.stringify(payload), // you are sending body instead
      headers: {
        // 'Authorization': `bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    // window.open(
    //   "https://ik.imagekit.io/syeovulacjk/sptools/asset/docs/pdf/2_IVcDPVtHpLV.pdf"

    // );
    pdfload(show.pdfId);
  };

  const handleEmail = (e) => {
    setEmailValue(e.target.value);
  };
  const handleName = (e) => {
    setNameValue(e.target.value);
  };
  const handleCompanyName = (e) => {
    setCompanyNameValue(e.target.value);
  };
  const handleMobile = (e) => {
    setMobileValue(e.target.value);
  };
  return (
    <>
      <div className="catologue-main-container">
        <h3 className="text-center m-3">Catalogues </h3>
        <Slider {...settings}>
          {CatogueContent.map((value, index) => (
            // <a
            //   href="https://ik.imagekit.io/syeovulacjk/sptools/asset/docs/pdf/2_IVcDPVtHpLV.pdf"
            //   target="_blank"
            // >

            <div
              className="catologue-container"
              key={value.id}
              onClick={() => handleShow(value.id)}
            >
              {" "}
              <p
                className={`catalog_new_tag ${
                  value.new ? "catalog_new_tag_present" : ""
                }`}
              >
                {" "}
                {value.new ? "New" : " "}
              </p>
              <img
                src={value.imageURL}
                // src={product_img}
                alt="Avatar"
                className="catologue-image"
              />
              <h2>{value.title}</h2>
            </div>

            // </a>
          ))}
        </Slider>
      </div>
      <Modal show={show.show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Catologues Download</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Name"
                onChange={(e) => handleName(e)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                onChange={(e) => handleEmail(e)}
              />
              <Form.Text className="text-muted">
                We'll never share your email with anyone else.
              </Form.Text>
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Company Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Company Name"
                onChange={(e) => handleCompanyName(e)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Mobile No.</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter Mobile Number"
                onChange={(e) => handleMobile(e)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => pdfloadView(show.pdfId)}>
            View Catalogue
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={
              NameValue.length < 3 ||
              EmailValue.length < 5 ||
              CompanyNameValue.length < 3 ||
              MobileValue.length < 10
            }
          >
            Download Catalogue
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
